import React from 'react';

const FILTER_OPTIONS = [
  { key: 'all', label: 'All Projects' },
  { key: 'mine', label: 'My Projects' },
];

const ProjectFilterToggle = ({ value = 'all', onChange }) => {
  return (
    <div
      className="project-filter-toggle"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        backgroundColor: '#e5edff',
        borderRadius: '999px',
        padding: '4px',
        gap: '4px',
      }}
      role="tablist"
      aria-label="Project filter"
    >
      {FILTER_OPTIONS.map((opt) => {
        const isActive = value === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => {
              if (!isActive && typeof onChange === 'function') {
                onChange(opt.key);
              }
            }}
            style={{
              border: 'none',
              borderRadius: '999px',
              padding: '6px 14px',
              fontSize: '13px',
              fontWeight: 600,
              cursor: 'pointer',
              backgroundColor: isActive ? '#4880FF' : 'transparent',
              color: isActive ? '#ffffff' : '#1e293b',
              boxShadow: isActive ? '0 2px 6px rgba(72,128,255,0.4)' : 'none',
              transition: 'background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease',
              whiteSpace: 'nowrap',
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = '#dbe4ff';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.backgroundColor = 'transparent';
              }
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};

export default ProjectFilterToggle;